import { render, staticRenderFns } from "./keys-list.vue?vue&type=template&id=37921f97&scoped=true&"
import script from "./keys-list.ts?vue&type=script&lang=ts&"
export * from "./keys-list.ts?vue&type=script&lang=ts&"
import style0 from "./keys-list.scss?vue&type=style&index=0&id=37921f97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37921f97",
  null
  
)

export default component.exports